// https://github.com/plebbit/lists/blob/master/README.md
export const nsfwTags = ['adult', 'gore', 'vulgar', 'anti'];
